/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-spread */
/* eslint-disable prettier/prettier */

/**
 *  Facebook Pixel 脚本 异步加载，根据不同广告系列ID加载不同 Pixel ID
 *  进来参数有 facebook_pixel_id 就替换，没有就取缓存，否则就取默认
 */
export default defineNuxtPlugin((nuxtApp) => {
  // 异步加载 Facebook Pixel 脚本
  // @ts-ignore
  // const loadFacebookPixel = (pixelId) => {
  //   if (!pixelId) {
  //     return
  //   }
  //   // @ts-ignore
  //   ; (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
  //     if (f.fbq) return
  //     n = f.fbq = function () {
  //       n.callMethod
  //         ? n.callMethod.apply(n, arguments)
  //         : n.queue.push(arguments)
  //     }
  //     if (!f._fbq) f._fbq = n
  //     n.push = n
  //     n.loaded = !0
  //     n.version = '2.0'
  //     n.queue = []
  //     t = b.createElement(e)
  //     t.async = !0
  //     t.src = v
  //     s = b.getElementsByTagName(e)[0]
  //     s.parentNode.insertBefore(t, s)
  //   })(
  //     window as any,
  //     document,
  //     'script',
  //     'https://connect.facebook.net/en_US/fbevents.js'
  //   )
  //   window['fbq']('init', pixelId)
  //   window['fbq']('track', 'PageView')
  //   // 插入 noscript 图片
  //   const noscript = document.createElement('noscript')
  //   noscript.innerText = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>`
  //   document.head.appendChild(noscript)
  // }
  // // 确保脚本在客户端加载
  // const runtimeConfig = useRuntimeConfig()
  // // 在生产或预发布环境才启动
  // if (process.client && (runtimeConfig.public.appMode === 'production' || runtimeConfig.public.appMode === 'release')) {
  //   const utmPixelId = common.getQueryVariable('facebook_pixel_id') // 先取url
  //   // 再依次判断取id
  //   const pixelId = utmPixelId || localStorage.getItem('utmFacebookPixelId') || nuxtApp.$config.public.defaultFacebookPixelId
  //   // 如果 utmPixelId 有id就存缓存
  //   if (utmPixelId) {
  //     localStorage.setItem('utmFacebookPixelId', utmPixelId) // 这个缓存会在退出登录时清除
  //   }
  //   loadFacebookPixel(pixelId)
  // }
})
